import { FC, useState } from 'react';
import Image, { ImageLoader, ImageProps } from 'next/legacy/image';
import { Box, SxProps } from '@mui/material';
import { SystemCssProperties } from '@mui/system';
import { colorGeneratorService } from '../../services';
import { getPublicFileUrl } from '../../utils/file.utils';
import ImageWrapper from './Image-wrapper';
import { FileVariantsEnum } from '@sweatpals/shared';
import { isUUID } from 'class-validator';
import { clsx } from '@sweatpals/react-ui-kit';

export type RemoteImageType = {
	src?: string | null;
	alt: string;
	exceptColor?: string;
	strictColor?: string;
	width: SystemCssProperties['width'];
	height: SystemCssProperties['height'];
	objectFit?: ImageProps['objectFit'];
	sx?: SxProps;
	variant?: FileVariantsEnum;
};

const RemoteImage: FC<RemoteImageType> = ({
	src,
	alt,
	width,
	height,
	sx,
	objectFit,
	exceptColor,
	strictColor,
	variant,
}) => {
	const [isAvailable, setIsAvailable] = useState<boolean>(true);
	const [color, setColor] = useState<string>(colorGeneratorService.color);
	const onErrorHandler = () => {
		setIsAvailable(false);
		const newColor = colorGeneratorService.getNextColor(exceptColor);
		setColor(newColor);
	};

	const srcLoader = ({ src, width, quality }): string =>
		isUUID(src) ? getPublicFileUrl(src, { width, quality, variant }) : src;

	return (
		<>
			{isAvailable && src ? (
				<ImageWrapper
					sx={clsx(
						{
							borderRadius: '24px',
							position: 'relative',
							overflow: 'hidden',
							width,
							height,
							flexShrink: '0',
							backgroundColor: 'color',
						},
						sx
					)}
				>
					<Image
						loader={srcLoader as ImageLoader}
						onError={onErrorHandler}
						src={src ?? ''}
						objectFit={objectFit ?? 'cover'}
						alt={alt}
						layout={'fill'}
						loading={'lazy'}
					/>
				</ImageWrapper>
			) : (
				<Box sx={{ width, height, borderRadius: '24px', backgroundColor: strictColor ?? color, ...sx }} />
			)}
		</>
	);
};

export default RemoteImage;
